import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=572e985c&scoped=true&"
import script from "./entity.vue?vue&type=script&lang=js&"
export * from "./entity.vue?vue&type=script&lang=js&"
import style0 from "./entity.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./entity.vue?vue&type=style&index=1&id=572e985c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e985c",
  null
  
)

export default component.exports